import zmFormula from "./zmFormulaHelperService";
import util from "zmfront-framework/src/utils/util";
import httpservice from "zmfront-framework/src/utils/httpservice";

const zmFlipRule = {};
//
zmFlipRule.facade = {};
//计抛规则
zmFlipRule.param = {};
zmFlipRule.weig = 0;
zmFlipRule.chargeVolume = 0;

const getCacheRefresh = function (str) {
    return new Promise((resolve,reject) => {
        if(str){
            //打开日期缓存 不存在就重新缓存
            if(str=="strDate"){
                let strDate =  util.get("strDate");
                if(strDate){
                    resolve(strDate);
                }else{
                    let newDate=new Date();
                    let detas = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                    util.set("strDate",detas);
                    resolve(detas);
                }
            } else if(str=="flipRuleList"){
                let flipRuleList = util.get("flipRuleList");;
                if(flipRuleList){
                    resolve(flipRuleList);
                }else{
                    httpservice.get('bas/flip/rule/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("flipRuleList", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
        }
    });
}

zmFlipRule.getResult = function (param) {
    // console.log(param);
    zmFormula.zmformulahelper(param.formula);
    zmFormula.setParam("@a", zmFlipRule.param.actual);
    zmFormula.setParam("@v", zmFlipRule.param.vol);
    zmFormula.setParam("@ea", zmFlipRule.param.endActual);
    zmFormula.setParam("@ev", zmFlipRule.param.endVol);
    zmFormula.setParam("@m", zmFlipRule.param.mVol?zmFlipRule.param.mVol:0);
    let weig = parseFloat(zmFormula.evalOfBigDecimal())
    return weig;
};

zmFlipRule.getResult2 = function (param) {
    let chargeVolume = zmFlipRule.param.mVol;
    if(param.volFormula){
        zmFormula.zmformulahelper(param.volFormula);
        zmFormula.setParam("@a", zmFlipRule.param.actual);
        zmFormula.setParam("@v", zmFlipRule.param.vol);
        zmFormula.setParam("@m", zmFlipRule.param.mVol?zmFlipRule.param.mVol:0);
        chargeVolume =parseFloat(zmFormula.evalOfBigDecimal());
    }
    return chargeVolume;
};
zmFlipRule.call = async function (param){
    zmFlipRule.param = param;
    let flipRuleList = await getCacheRefresh("flipRuleList");

    if (flipRuleList == null || flipRuleList.length < 1) {
        zmFlipRule.weig = zmFlipRule.param.actual > zmFlipRule.param.vol ? zmFlipRule.param.actual : zmFlipRule.param.vol;
        // zmFlipRule.chargeVolume = zmFlipRule.param.mVol;
        return zmFlipRule;
    }
    let flipRule = {};
    for (var i = 0; i < flipRuleList.length; i++) {
        if (flipRuleList[i].id == param.flipRuleId) {
            flipRule = flipRuleList[i];
        }
    }
    if (!flipRule || JSON.stringify(flipRule) == "{}") {
        zmFlipRule.weig = zmFlipRule.param.actual > zmFlipRule.param.vol ? zmFlipRule.param.actual : zmFlipRule.param.vol;
        // zmFlipRule.chargeVolume = zmFlipRule.param.mVol;
    } else {
        let weig = zmFlipRule.getResult(flipRule);
        zmFlipRule.weig = parseFloat(weig).toFixed(3);
        // let chargeVolume = zmFlipRule.getResult2(flipRule);
        // zmFlipRule.chargeVolume =parseFloat(chargeVolume).toFixed(3);
    }
    zmFlipRule.weig ? parseFloat(zmFlipRule.weig) : 0;
    // zmFlipRule.chargeVolume ? parseFloat(zmFlipRule.chargeVolume) : 0;
    return zmFlipRule;
};



const getWeig = function(flipRuleList){
    if (flipRuleList == null || flipRuleList.length < 1) {
        zmFlipRule.param.actual > zmFlipRule.param.vol ? zmFlipRule.param.actual : zmFlipRule.param.vol;
        // zmFlipRule.chargeVolume = zmFlipRule.param.mVol;
        return zmFlipRule;
    }
    let flipRule = {};
    for (var i = 0; i < flipRuleList.length; i++) {
        if (flipRuleList[i].id == zmFlipRule.param.flipRuleId) {
            flipRule = flipRuleList[i];
        }
    }
    if (!flipRule || JSON.stringify(flipRule) == "{}") {
        zmFlipRule.weig = zmFlipRule.param.actual > zmFlipRule.param.vol ? zmFlipRule.param.actual : zmFlipRule.param.vol;
        // zmFlipRule.chargeVolume = zmFlipRule.param.mVol;
    } else {
        let weig = zmFlipRule.getResult(flipRule);
        zmFlipRule.weig = parseFloat(weig).toFixed(3);
        // let chargeVolume = zmFlipRule.getResult2(flipRule);
        // zmFlipRule.chargeVolume =parseFloat(chargeVolume).toFixed(3);
    }
    zmFlipRule.weig ? parseFloat(zmFlipRule.weig) : 0;
    // zmFlipRule.chargeVolume ? parseFloat(zmFlipRule.chargeVolume) : 0;
    return zmFlipRule;

}


zmFlipRule.callAsync =  function (param){
    return new Promise((resolve,reject) => {
        zmFlipRule.param = param;
        let flipRuleList = getCacheRefresh("flipRuleList").then((res)=>{
                if (res) {
                    util.set("flipRuleList", res);
                    let weig = getWeig(res);
                    resolve(weig)
                }
            })
        });
};



export default zmFlipRule;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmFlipRuleService.js